//import MakeorderSM from "./screen/makeorder/makeorderSM";
//import Makeorder from "./screen/makeorder/makeorder";
import { Makeorder as Make, MakeorderLoad } from "./screen/makeorder";

//import MakeorderOrder from "./screen/makeorder/makeorderOrder";
import {
  cartApi  
} from "./api/cartService";
const routes = [
 
  {
    type: "collapse",
    name: "Корзина",
    key: "makeorder",
    route: "/makeorder",
    icon: "",
    loader: ()=>{
      return cartApi()
    },
    component: <Make />,
    noCollapse: true,
  },

];


/*

 {
    type: "collapse",
    name: "Корзина",
    key: "makeorderSM",
    route: "/makeorderSM",
    icon: "",
    component: <MakeorderSM />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Корзина",
    key: "makeorderUser",
    route: "/makeorderUser",
    icon: "",
   
    component: <Makeorder />,
    noCollapse: true,
  },
    {
    type: "collapse",
    name: "Замовлення",
    key: "makeorder",
    route: "/makeorder/makeorderOrder",
    icon: "",
    component: <MakeorderOrder />,
    noCollapse: true,
  },
*/

export default routes;
